import { commitMutation, graphql } from 'react-relay';

interface SubmitContactFormInputDataGraphQLType {
    name : string;
    value : string;
}

interface SubmitContactFormVariables {
    input: {
        clientMutationId: string;
        data: SubmitContactFormInputDataGraphQLType[];
        formPageId: string;
    };
}

const mutation = graphql `
    mutation submitContactFormMutation($input: SubmitContactFormInput!) {
        submitContactForm(input: $input) {
            clientMutationId
            successUrl
            returnMessage
        }
    }
`;

function submitContactForm(
    environment: any,
    variables: { data: SubmitContactFormInputDataGraphQLType[]; formPageId: string },
    onSuccess?: ( response: any ) => void,
    onError?: ( error: Error ) => void
) {
    const mutationVariables: SubmitContactFormVariables = {
        input: {
            clientMutationId: `mutation-${ Date.now() }`,
            data: variables.data,
            formPageId: variables.formPageId,
        },
    };

    commitMutation( environment, {
        mutation,
        variables: mutationVariables,
        onCompleted: ( response, errors ) => {
            if ( errors ) {
                onError( new Error( errors[0].message ) );
            } else {
                onSuccess( response );
            }
        },
        onError: ( error ) => {
            onError( error );
        },
    } );
}

export { submitContactForm as default, SubmitContactFormInputDataGraphQLType };

// @TODO - LEGACY code, remove comments
// class SubmitContactFormMutation extends Relay.Mutation<SubmitContactFormPropTypes, {}> {
//     getMutation() {
//         return Relay.QL`mutation { submitContactForm }`;
//     }

//     getVariables() {
//         const { contactFormData: data, formPageId } = this.props;

//         return {
//             data,
//             formPageId,
//         };
//     }

//     getFatQuery() {
//         return Relay.QL`
//             fragment on SubmitContactFormPayload {
//                 successUrl
//                 returnMessage
//             }
//         `;
//     }

//     getConfigs() {
//         return [ {
//             type: 'REQUIRED_CHILDREN',
//             children: [ Relay.QL`
//                 fragment on SubmitContactFormPayload {
//                     successUrl
//                     returnMessage
//                 }
//             ` ],
//         } ];
//     }
// }

// export { SubmitContactFormMutation as default, SubmitContactFormInputDataGraphQLType };
